export class RequestListMapExcel {
  static mapExcel(jsonData, isRetailer: boolean) {
    const exportArray = jsonData.map((val) => {
      if (isRetailer) {
        const rObj = {
          'ID pedido': val.requestMainId,
          CPE: val.requestCpe,
          'Estado atual': val.statusTitle,
          'Área atual': val.requestArea,
          'Tipo atual': val.requestType,
          'Sub-tipo atual': val.requestSubType,
          'Criado por': val.createdBy,
          'Data da última resposta': val.lastResponseDate,
          'Resposta criada por': val.lastResponder,
        };

        return rObj;
      } else {
        const rObj = {
          'ID pedido': val.requestMainId,
          'Estado atual': val.statusTitle,
          Comercializador: val.retailerName,
          CPE: val.requestCpe,
          'Nível de tensão atual': val.voltageLevelName,
          'Pasta atual': val.folderTitle,
          'Área atual': val.requestArea,
          'Tipo atual': val.requestType,
          'Sub-tipo atual': val.requestSubType,
          'Criado por': val.requestTransactionUser ? val.requestTransactionUser : val.createdBy,
          'Data de criação': val.createdAt,
          'Atribuído a': val.assignedUserName,
          'Data da última resposta do comercializador': val.lastRetailerResponseDate,
          'Data da última resposta EDP': val.lastOrdResponseDate,
          'Última Resposta EDP': val.lastOrdResponseUser,
          'Pedido reaberto': val.alreadySolved,
          Descrição: val.description,
        };

        return rObj;
      }
    });

    return exportArray;
  }
}
